import React, { useState, useEffect } from "react";
import moment from "moment";
import { faCopy, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../App.css";

const TimeStampWidget = ({ timestamps, setTimestamps }) => {
  const [format, setFormat] = useState("t");
  const [copyActive, setCopyActive] = useState(false);
  const [error, setError] = useState(null);
  const [generatedTimestamps, setGeneratedTimestamps] = useState("");
  const [displayedTimestamps, setDisplayedTimestamps] = useState("");
  const [rotated, setRotated] = useState(false);

  useEffect(() => {
    const updateDisplayedTimestamps = () => {
      if (timestamps.length > 0) {
        const formattedTimestamps = timestamps
          .map((time) => `<t:${moment(time).unix()}:${format}>`)
          .join(", ");
        setGeneratedTimestamps(formattedTimestamps);
        const humanReadableTimestamps = timestamps
          .map((time) => getMomentFormat(format, time))
          .join("\n");
        setDisplayedTimestamps(humanReadableTimestamps);
      } else {
        setGeneratedTimestamps("");
        setDisplayedTimestamps("Timestamps Will Appear Here");
      }
    };
    updateDisplayedTimestamps();
    let interval;
    if (format === "R") {
      interval = setInterval(updateDisplayedTimestamps, 1000);
    }
    return () => clearInterval(interval);
  }, [timestamps, format]);

  const getMomentFormat = (discordFormat, time) => {
    const formats = {
      t: "h:mm A",
      T: "HH:mm:ss",
      d: "MM/DD/YYYY",
      D: "dddd, MMMM D, YYYY",
      f: "MMMM D, YYYY h:mm A",
      F: "dddd, MMMM D, YYYY h:mm A",
    };
    if (discordFormat === "R") {
      return moment(time).fromNow();
    }
    return moment(time).format(formats[discordFormat] || "LLLL");
  };

  const handleFormatChange = (event) => {
    setFormat(event.target.value);
    setCopyActive(false);
  };

  const copyToClipboard = () => {
    if (generatedTimestamps) {
      navigator.clipboard
        .writeText(generatedTimestamps)
        .then(() => {
          setCopyActive(true);
          setTimeout(() => setCopyActive(false), 2000);
        })
        .catch((err) => {
          setError("Failed to copy.");
          console.error("Copy error: ", err);
        });
    }
  };

  const resetTimestamps = () => {
    if (setTimestamps) {
      setTimestamps();
    }
    setFormat("t");
    setCopyActive(false);
    setError(null);
    setRotated(!rotated);
  };

  return (
    <div className="flex flex-col justify-center items-center w-full font-lexend gap-4 font-bold">
      <div
        className={`fixed top-5 px-4 py-2 -full bg-white text-[#111] transition-opacity duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] 
    ${copyActive ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      >
        COPIED
      </div>
      <div className="flex flex-row justify-between items-center gap-4 w-full">
        <select
          value={format}
          onChange={handleFormatChange}
          className="bg-white text-[#111] w-full p-2 border-2 border-zinc-600/50 focus:outline-none appearance-none shadow-[0_4px_10px_rgba(0,0,0,0.7)]"
        >
          <option value="t">Short Time (t)</option>
          <option value="d">Short Date (d)</option>
          <option value="D">Long Date (D)</option>
          <option value="T">Long Time (T)</option>
          <option value="f">Long Date (f)</option>
          <option value="F">Long Date with Time (F)</option>
          <option value="R">Relative Time (R)</option>
        </select>

        <div className="flex flex-row gap-4 justify-between items-center">
          <button
            onClick={copyToClipboard}
            disabled={!generatedTimestamps}
            className="flex justify-center items-center p-2 rounded-full w-10 h-10 text-[#111] bg-white border-2 border-zinc-600/50 transition-all duration-400 ease-[cubic-bezier(0.4, 0, 0.2, 1)] cursor-pointer active:shadow-[inset_2px_4px_4px_6px_rgba(0,0,0,0.4)]"
          >
            <FontAwesomeIcon icon={faCopy} title={displayedTimestamps} />
            {error && <div className="error">{error}</div>}
          </button>
          <button
            onClick={resetTimestamps}
            className="flex justify-center items-center p-2 rounded-full w-10 h-10 text-[#111] bg-white border-2 border-zinc-600/50 transition-all duration-400 ease-[cubic-bezier(0.4, 0, 0.2, 1)] curson-pointer active:shadow-[inset_2px_4px_4px_6px_rgba(0,0,0,0.4)] "
          >
            <FontAwesomeIcon icon={faRotateRight} />
          </button>
        </div>
      </div>
      <textarea
        className="h-14 w-full py-1 px-2 bg-white text-[#111]  focus:outline-none resize-none  border-2 border-zinc-600/50"
        value={displayedTimestamps}
        readOnly
      />
    </div>
  );
};

export default TimeStampWidget;
